module.exports = __webpack_public_path__ + "assets/img/sphere-stars.150d16f1.png";